module.exports = __webpack_public_path__ + "media/images/banner3-9345432e2feb5e98798288c704571c18.jpg";